import React, {useContext, useEffect} from "react"
import _ from "lodash"

// util
import Util from "../../../../util"

// context
import {CatalogueContext} from "../../../../context/CatalogueContext"
import {FavouritesContext} from "../../../../context/FavouritesContext"

// components & context providers
import {HtmlHeader, Scaffolding} from "../../../shared"
import {ActivityLink, Link} from "../../../controls"
//import {ScrollProvider } from "../../../../context/ScrollContext"

// styling
import "./Favourites.scss"

// the component
const Favourites = () => {
  // get our context
  const catalogue = useContext(CatalogueContext)
  const favourites = useContext(FavouritesContext)

  // scroll to top when mounting
  useEffect(() => { Util.Scroll.scrollToTop()}, [])

  // content to display, depending on whether favourites were collected or not
  let content = null
  if(!catalogue.isReady) {
    return null
  }
  else if(favourites.count === 0) {
    // no favourites
    content = (
      <>
        <div id="v-favourites-list-empty">
          <h2>Noch keine Favoriten</h2>
          <p>
            Du hast noch keine Favoriten hinzugefügt.
          </p>
          <p>
            Klicke einfach auf das Herz bei Aktivitäten die dir gefallen, um sie deiner Liste der Favoriten hinzuzufügen.
          </p>
        </div>
        <Link to="/" className="button">Aktivitäten durchsuchen</Link>
      </>
    )
  }
  else {
    // collect items to display
    let items = favourites.items
      .map(f_id => {
        return (catalogue.activities.all || []).find(a => a._id === f_id)
      })
      .filter(a => !_.isNil(a))
      .map(a => <ActivityLink activity={a} key={a._id} />)

    /*
    content = (
      <>
        <div id="v-favourites-list">
          <ScrollProvider>
            {items}
          </ScrollProvider>
        </div>
        <Link to="/" className="button">alle Aktivitäten anzeigen</Link>
      </>
    )
    */
   content = (
    <>
      <div id="v-favourites-list">
        {items}
      </div>
      <Link to="/" className="button">alle Aktivitäten anzeigen</Link>
    </>
  )
  }

  // render
  return (
    <Scaffolding>
      <HtmlHeader title="Appentura - Favoriten" />
      <div id="v-favourites">
        <h1>Deine Favoriten</h1>
        {content}
      </div>
    </Scaffolding>
  )
}

export default Favourites